const baseStyle = {
  padding: '16px',
  borderBottom: 'muted'
}

export default {
  baseStyle
}
